export default __webpack_public_path__ + "static/media/event_1.76c82ede.png";